export default {
      id: "ic_hamburger-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic_hamburger-usage",
      toString: function () {
        return this.url;
      }
    }